var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { translate } from '@utils/i18n';
import toast from 'react-hot-toast';
import { ToastDuration, IndexNamespace } from '../constants';
import { getActivities } from '../services/ActivitiesService';
export function getActivityQueryKey(buildingId, params, inspectionId, invoiceId, workOrderId, deficiencyId, proposalId) {
    return [
        'activities',
        buildingId,
        inspectionId,
        invoiceId,
        workOrderId,
        deficiencyId,
        proposalId,
        params.type.sort().join(','),
        params.sort
    ];
}
export default function useActivitiesQueries({ buildingId, inspectionId, invoiceId, workOrderId, deficiencyId, proposalId, params }) {
    const queryKey = getActivityQueryKey(buildingId, params, inspectionId, invoiceId, workOrderId, deficiencyId, proposalId);
    const { data, isLoading, isFetchingNextPage, error, fetchNextPage, hasNextPage } = useInfiniteQuery({
        queryKey,
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam = 1 }) {
            return getActivities({
                buildingId,
                inspectionId,
                invoiceId,
                workOrderId,
                deficiencyId,
                proposalId,
                params: Object.assign(Object.assign({}, params), { page: pageParam })
            });
        }),
        getNextPageParam: (lastPage) => {
            var _a;
            const pagination = (_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.data) === null || _a === void 0 ? void 0 : _a.pagination;
            if (!pagination)
                return undefined;
            return pagination.currentPage < pagination.totalPages ? pagination.currentPage + 1 : undefined;
        },
        onError: () => {
            toast.error(translate('load_notes_error', { namespace: IndexNamespace }), {
                position: 'bottom-right',
                duration: ToastDuration
            });
        },
        retry: false,
        refetchOnWindowFocus: false
    });
    const activities = useMemo(() => {
        if (!(data === null || data === void 0 ? void 0 : data.pages))
            return [];
        return data.pages.flatMap((page) => page.data.data).reverse();
    }, [data]);
    const fetchMore = () => {
        if (hasNextPage)
            void fetchNextPage();
    };
    return {
        activities,
        isLoading: isLoading || isFetchingNextPage,
        error,
        hasMore: !!hasNextPage,
        fetchMore
    };
}
